/**
 * Datos de preguntas frecuentes
 * Centralizado para fácil mantenimiento y actualizaciones
 */

export const FAQS = [
  { 
    question: "¿Cuáles son los horarios y días que se manejan?", 
    answer: "Ofrecemos servicios de forma semanal, quincenal y mensual. Nos adaptamos a las necesidades del paciente, asegurando disponibilidad 24/7. Los turnos comunes son de 8, 12 o 24 horas, con flexibilidad para ajustarnos a requerimientos específicos.",
    id: "horarios",
    category: "servicios",
    tags: ["horarios", "disponibilidad", "turnos"]
  },
  { 
    question: "¿Cómo se realiza la contratación del servicio?", 
    answer: "Cuando nos contactes en Geriatría Serena, te proporcionaremos una asesoría detallada para elegir el servicio adecuado. La contratación puede ser de forma presencial o en línea. Requerimos identificación oficial, comprobante de domicilio y firmar un contrato que detalla los términos del servicio.",
    id: "contratacion",
    category: "administrativo",
    tags: ["contrato", "documentación", "proceso"]
  },
  { 
    question: "¿El servicio puede darse fuera de Guadalajara?", 
    answer: "Estamos enfocados en proporcionar servicios en Guadalajara y área metropolitana (Zapopan, Tlaquepaque, Tonalá), pero se pueden evaluar casos especiales en localidades cercanas según disponibilidad. Para servicios fuera del área metropolitana aplica un cargo adicional por desplazamiento.",
    id: "cobertura",
    category: "cobertura",
    tags: ["ubicación", "área metropolitana", "cobertura"]
  },
  { 
    question: "¿Qué incluyen los servicios de enfermería?", 
    answer: "Nuestros servicios incluyen: administración de medicamentos, control de signos vitales, curaciones, apoyo en higiene personal, alimentación, movilización, acompañamiento a citas médicas y seguimiento del estado de salud. Cada servicio se personaliza según las necesidades del paciente.",
    id: "servicios-incluyen",
    category: "servicios",
    tags: ["servicios", "cuidados", "enfermería"]
  },
  { 
    question: "¿Qué métodos de pago aceptan?", 
    answer: "Aceptamos transferencias bancarias, depósitos en efectivo y pagos con tarjeta de crédito/débito (con una comisión del 3%). Para contratos mensuales ofrecemos descuentos especiales y facilidades de pago.",
    id: "pagos",
    category: "administrativo",
    tags: ["pagos", "tarifas", "descuentos"]
  },
  {
    question: "¿Cómo se factura el servicio?",
    answer: "Emitimos factura electrónica (CFDI) por cada periodo contratado y la enviamos al área administrativa de su empresa. Podemos consolidar facturación semanal o mensual según su política interna, con desglose claro de turnos, perfiles asignados y servicios clínicos realizados.",
    id: "facturacion-corporativa",
    category: "administrativo",
    tags: ["facturación", "corporativo", "administración"]
  },
  {
    question: "¿Qué pasa si la enfermera asignada tiene una emergencia (cobertura garantizada)?",
    answer: "Activamos un protocolo de cobertura garantizada con personal de respaldo previamente validado. Nuestro equipo operativo coordina el relevo sin interrumpir la atención del paciente y notifica a su enlace corporativo en tiempo real para mantener continuidad total del servicio.",
    id: "cobertura-garantizada",
    category: "cobertura",
    tags: ["cobertura", "continuidad", "respaldo"]
  },
  {
    question: "¿Cómo se realiza la supervisión clínica de los casos?",
    answer: "Cada caso cuenta con supervisión clínica periódica por coordinación de enfermería, revisión de evolución y seguimiento de incidencias. Compartimos reportes ejecutivos con hallazgos relevantes, cumplimiento del plan de cuidados y recomendaciones de ajuste para asegurar calidad asistencial.",
    id: "supervision-clinica",
    category: "calidad",
    tags: ["supervisión", "calidad", "seguimiento"]
  },
  {
    question: "¿Cuentan con contratos flexibles mensuales?",
    answer: "Sí. Ofrecemos contratos mensuales flexibles para clientes corporativos y premium, con posibilidad de escalar o reducir horas, cambiar perfiles de atención y ajustar coberturas conforme cambien sus necesidades operativas, manteniendo términos claros y transparentes.",
    id: "contratos-flexibles-mensuales",
    category: "administrativo",
    tags: ["contrato", "flexibilidad", "mensual"]
  },
  { 
    question: "¿Proporcionan servicios de emergencia?", 
    answer: "Sí, contamos con servicio de urgencias disponibles las 24 horas los 365 días del año. Nuestro tiempo de respuesta promedio es de 2-4 horas dependiendo de la ubicación. Para emergencias médicas críticas recomendamos acudir primero a un hospital.",
    id: "emergencias",
    category: "servicios",
    tags: ["urgencias", "emergencias", "disponibilidad"]
  },
  { 
    question: "¿Qué certificaciones tienen sus enfermeras?", 
    answer: "Todo nuestro personal cuenta con cédula profesional vigente, certificaciones en cuidados geriátricos y experiencia comprobada. Realizamos verificaciones de antecedentes y capacitación continua para garantizar los más altos estándares de calidad.",
    id: "certificaciones",
    category: "calidad",
    tags: ["certificaciones", "profesionales", "calidad"]
  },
  { 
    question: "¿Puedo cambiar de cuidadora si no hay compatibilidad?", 
    answer: "Sí, entendemos que la compatibilidad personal es fundamental. Ofrecemos cambios sin costo durante los primeros 3 días de servicio si no hay compatibilidad con la cuidadora asignada.",
    id: "cambios",
    category: "servicios",
    tags: ["cambios", "compatibilidad", "satisfacción"]
  }
];

// Categorías de FAQs
export const FAQ_CATEGORIES = [
  { id: 'todos', name: 'Todas las categorías' },
  { id: 'servicios', name: 'Servicios' },
  { id: 'administrativo', name: 'Administrativo' },
  { id: 'cobertura', name: 'Cobertura' },
  { id: 'calidad', name: 'Calidad' }
];

// Tags populares para filtrado rápido
export const POPULAR_TAGS = [
  "urgencias", "pagos", "horarios", "cuidados", 
  "contrato", "certificaciones", "disponibilidad"
];
